import { render, staticRenderFns } from "./GraphDetail15.vue?vue&type=template&id=61fa7731&scoped=true&"
import script from "./GraphDetail15.vue?vue&type=script&lang=js&"
export * from "./GraphDetail15.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61fa7731",
  null
  
)

export default component.exports